import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Avatar from 'shared/components/common/Avatar/Avatar.component'
import { createDivAtom } from 'shared/atoms/factory'

import styles from './Item.module.scss'

const IconWrapper = createDivAtom()
const TitleWrapper = createDivAtom()

const Item = props => (
  <main
    className={styles.wrapper}
    onClick={props.onClick}
  >

    {props.avatar && (
      <IconWrapper
        className={styles.icon}
      >
        <Avatar
          subject={{ name: props.title }}
          size='tiny'
        />
      </IconWrapper>
    )}

    {props.icon && (
      <IconWrapper
        className={styles.icon}
      >
        <img src={props.icon}/>
      </IconWrapper>
    )}

    <TitleWrapper
      className={classNames(
        styles.title,
        props.titleClassName
      )}
    >
      {props.title}
    </TitleWrapper>
  </main>
)

Item.propTypes = {
  title: PropTypes.string.isRequired,
  titleClassName: PropTypes.string,
  avatar: PropTypes.bool,
  icon: PropTypes.string,
  onClick: PropTypes.func
}

export default Item
